import { useEffect, useState } from "react";
import styles from "./index.module.scss";
import { TEmbedArticles, TEmbedArticlesData } from "../../../types/INote";
import PhotoAPI from "../../../services/photo-api";

export default function UomArticleRelated({
  articleId,
  embedArticles,
}: {
  articleId: string;
  embedArticles?: TEmbedArticles;
}): JSX.Element {
  const [data, setData] = useState<TEmbedArticlesData | undefined>();
  useEffect(() => {
    if (embedArticles && embedArticles[articleId]) {
      setData({
        url: embedArticles[articleId].url,
        mainImage: PhotoAPI.photoFromUrl(embedArticles[articleId].mainImage, "II"),
        title: embedArticles[articleId].title,
      });
    }
  }, []);

  return (
    <>
      {data && data.url && data.title && (
        <div className={styles.art_related}>
          <a
            className={styles.art_related__link}
            href={`${data.url}`}
            data-bd-viewability-id="art_related"
            data-bd-viewability-href={data.url}
            data-bd-viewability="1"
            title={data.title}
          >
            {data.mainImage && (
              <img className={styles.art_related__image} src={`${data.mainImage}#e=RelArtImg(1)`} alt={data.title} />
            )}
            <span className={styles.art_related__title}>{data.title}</span>
          </a>
        </div>
      )}
    </>
  );
}
